import { Podcast, type InteractiveUiConfig } from '@knolskape/educate-components';
import type { EducateModule } from '@/hooks/useEducateModule';
import { useProductHost } from '../../host/useProductHost';

export const PodcastHost = ({ module }: { module: EducateModule }) => {
  const props = useProductHost(module);
  if (!props) return null;
  return (
    <Podcast
      config={props.config as InteractiveUiConfig}
      content={props.content}
      mode="play"
      host={props.host}
      storylineId={props.storylineId}
    />
  );
};
